import React from 'react';
import styles from './button.module.scss';

export interface Props {
  variant?: 'primary' | 'secondary' | 'tertiary';
}

export default function Button(
  props: Props & React.ButtonHTMLAttributes<HTMLButtonElement>
) {
  return (
    <button
      type="button"
      {...props}
      className={`${styles.button} ${styles[props.variant || 'primary']} ${props.className || ''}`}
    >
      {props.children}
    </button>
  );
}
